// ====================
// components/SkillsSection.js
// ====================

import React from 'react';
import { Code, Database, Server } from 'lucide-react';

const SkillsSection = () => {
  const skillCategories = [
    {
      icon: <Code size={24} />,
      title: 'Programming Languages',
      skills: ["C++", "Go", 'Python', 'Zig', 'JavaScript', 'SQL', 'Bash/PowerShell']
    },
    {
      icon: <Database size={24} />,
      title: 'Web & Database',
      skills: ['React/React Native', 'JavaScript Frameworks', 'HTML/CSS', 'MySQL', 'Firebase']
    },
    {
      icon: <Server size={24} />,
      title: 'Systems & Administration',
      skills: ['Active Directory', 'Microsoft 365', 'NinjaRMM', 'System Administration']
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2>Technical Skills</h2>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <div className="category-header">
                {category.icon}
                <h3>{category.title}</h3>
              </div>
              <div className="skill-items">
                {category.skills.map((skill, skillIndex) => (
                  <span key={skillIndex} className="skill-item">{skill}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;